(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/createClass"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/createClass"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.createClass);
    global.Deferrable = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _createClass2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = void 0;
  _createClass2 = _interopRequireDefault(_createClass2);

  var Deferrable = /*#__PURE__*/function () {
    function Deferrable() {
      this.deferTasks_ = [];
    }

    var _proto = Deferrable.prototype;

    _proto.consumeDeferTasks = function consumeDeferTasks(error) {
      if (!this.deferTasks_.length) {
        return;
      }

      this.deferTasks_.forEach(function (task) {
        if (error) {
          task.reject && task.reject(error);
        } else {
          task.callback && task.callback();
        }
      });
      this.deferTasks_ = [];
    };

    _proto.pushTask = function pushTask(name, fn, rej) {
      // do not remove task, because the original promise dependent on those resolve/reject.
      // this.removeTask(name);
      console.log("push task", name);
      this.deferTasks_.push({
        name: name,
        callback: fn,
        reject: rej
      });
    };

    _proto.removeTask = function removeTask(name) {
      var foundIndex = -1;

      for (var i = 0; i < this.deferTasks_.length; i++) {
        if (this.deferTasks_[i].name === name) {
          foundIndex = i;
          break;
        }
      }

      if (foundIndex !== -1) {
        var task = this.deferTasks_[foundIndex];

        if (task && task.reject) {
          task.reject(new Error("remove from defer task"));
        }

        this.deferTasks_.splice(foundIndex, 1);
      }
    };

    _proto.clearTasks = function clearTasks() {
      this.deferTasks_ = [];
    };

    (0, _createClass2["default"])(Deferrable, [{
      key: "hasDeferTask",
      get: function get() {
        return !!this.deferTasks_.length;
      }
    }]);
    return Deferrable;
  }();

  _exports["default"] = Deferrable;
});
//# sourceMappingURL=Deferrable.js.map